import { render, staticRenderFns } from "./ItemChipsWithMoreV2.vue?vue&type=template&id=c7d27a52&scoped=true"
import script from "./ItemChipsWithMoreV2.vue?vue&type=script&lang=ts"
export * from "./ItemChipsWithMoreV2.vue?vue&type=script&lang=ts"
import style0 from "./ItemChipsWithMoreV2.vue?vue&type=style&index=0&id=c7d27a52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d27a52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7d27a52')) {
      api.createRecord('c7d27a52', component.options)
    } else {
      api.reload('c7d27a52', component.options)
    }
    module.hot.accept("./ItemChipsWithMoreV2.vue?vue&type=template&id=c7d27a52&scoped=true", function () {
      api.rerender('c7d27a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ItemChipsWithMoreV2.vue"
export default component.exports